import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'

export const StyledRow = styled(Container)`
  gap: 12px;
`

export const StyledRanges = styled(Container)`
  gap: 8px;
  flex-wrap: wrap;
`

export const TimeInput = styled.input`
  width: 180px;
  height: 56px;
  padding: 15px;
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  font-size: ${({theme}) => theme.fontSize.lg};
  line-height: ${({theme}) => theme.lineHeight.lg};
  color: ${({theme}) => theme.colors.inputText};
`

export const ModalContent = styled(Container)`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const ModalBody = styled(Container)`
  flex: 1;
  overflow-y: auto;
`

export const AvailabilityDetailsCard = styled(Container)`
  background-color: ${({theme}) => theme.colors.grey.grey20};
  border: 1px solid ${({theme}) => theme.colors.grey.grey150};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  padding: ${({theme}) => theme.spacing.md};
  box-shadow: ${({theme}) => theme.boxShadow.card};
  margin-top: auto;

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      ${({theme}) => theme.colors.grey.grey300},
      transparent
    );
  }

  position: relative;
`
